import { CompanyId } from '@/domain/models/company/company-id'
import { CompanyName } from '@/domain/models/company/company-name'

export const companyNameById: Record<CompanyId, CompanyName> = {
  [CompanyId.Natura]: CompanyName.Natura,
  [CompanyId.Avon]: CompanyName.Avon,
}
